// extracted by mini-css-extract-plugin
export default {"titleContainer":"TitleContainer_titleContainer__Kh-3B"};